module.exports = __webpack_public_path__ + "dfb2c7a4f593e5f35fd5243b9b799ada.pdf";